<template>
<Layout>
    <div class="news">
    </div>
</Layout>
</template>

<script>
import Layout from '@/layouts/Layout.vue'

export default {
name: 'News',
components: {
    Layout,
}
}
</script> 

<style scoped>
.news {
    margin-top: 80px;
}
</style>